import request from 'axios';
import { PROJECT_ENTRIES_RESOURCE_NAME } from 'admin/constants';
import { getAPIQueryString } from 'common/utils';
import { savePageCount } from 'common/pager/ducks';

/* ACTIONS
================================================================================================ */
const FETCH_ALL = 'crowdspring/admin/FETCH_PROJECT_ENTRIES';
const FETCH_ALL_REQUEST = 'crowdspring/admin/FETCH_PROJECT_ENTRIES_REQUEST';
const FETCH_ALL_SUCCESS = 'crowdspring/admin/FETCH_PROJECT_ENTRIES_SUCCESS';

const CLEAR_ALL = 'crowdspring/admin/CLEAR_PROJECT_ENTRIES';

const SET_VIEW_TYPE = 'crowdspring/admin/SET_VIEW_TYPE';

const SET_GROUPING = 'crowdspring/admin/SET_GROUPING';

const WITHDRAW = 'crowdspring/admin/WITHDRAW_PROJECT_ENTRIES';
const WITHDRAW_SUCCESS = 'crowdspring/admin/WITHDRAW_PROJECT_ENTRIES_SUCCESS';

const REMOVE_CREATIVE = 'crowdspring/admin/REMOVE_CREATIVE';
const REMOVE_CREATIVE_SUCCESS = 'crowdspring/admin/REMOVE_CREATIVE_SUCCESS';

/* HELPERS
================================================================================================ */
export const getEntries = (state) => {
  const { list, grouped } = state.admin.projectEntries;
  if (grouped) {
    return list;
  }
  /* if not grouped, return an entry copy for each revision */
  return list.reduce((acc, entry) => {
    entry.revisions.forEach(rev => acc = acc.concat({ ...entry, revisions: [rev] }));
    return acc;
  }, []);
}

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  list: [],
  isFetching: false,
  grouped: false
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_ALL_SUCCESS:
      return {
        ...state,
        list: action.payload.results,
        isFetching: false
      };
    case CLEAR_ALL:
      return {
        ...state,
        list: []
      };
    case SET_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload
      };
    case SET_GROUPING:
      return {
        ...state,
        grouped: action.payload
      };
    case WITHDRAW_SUCCESS:
    case REMOVE_CREATIVE_SUCCESS:
      return {
        ...state,
        list: state.list.map(entry => (
          action.payload.includes(entry.id)?
          { ...entry, withdrawn: true, withdrawn_by_admin: true } : entry
        ))
      };
    default:
      return state;
  }
}

export const fetchAll = (projectId, query) => (dispatch, getState) => {
  const queryStr = getAPIQueryString(PROJECT_ENTRIES_RESOURCE_NAME, query);
  const promise = request.get(`/api/v1/projects/${projectId}/entries/?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(PROJECT_ENTRIES_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH_ALL,
    promise
  });
};

export const clearAll = () => {
  return {
    type: CLEAR_ALL,
  };
}

export const setViewType = (type) => {
  return {
    type: SET_VIEW_TYPE,
    payload: type
  };
}

export const setGrouping = (grouped) => {
  return {
    type: SET_GROUPING,
    payload: grouped
  };
}

export const withdraw = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: WITHDRAW,
    promise: request.put(`/api/v1/radmin/users/${creativeId}/withdraw_entries/`, data),
  });
};

export const removeCreative = (creativeId, data) => (dispatch) => {
  return dispatch({
    type: REMOVE_CREATIVE,
    promise: request.put(`/api/v1/radmin/users/${creativeId}/remove_creative/`, data),
  });
};
